import type { HighlightRange } from '../../api/catalog';
import { splitHighlightSegments } from './highlight';
import './Highlighted.css';

/** Renders `text` with every range from `highlightRanges()` wrapped in a `<mark>` — the library
 * grid/list's "highlighted matches" (AC-UI-3). An empty `ranges` array (no query, or a
 * diacritic/compact-tier match with nothing literal to underline) renders plain text. */
export function Highlighted({ text, ranges }: { text: string; ranges: readonly HighlightRange[] }) {
  const segments = splitHighlightSegments(text, ranges);
  return (
    <>
      {segments.map((segment, i) =>
        segment.matched ? (
          <mark key={i} className="song-highlight">
            {segment.text}
          </mark>
        ) : (
          <span key={i}>{segment.text}</span>
        )
      )}
    </>
  );
}
